import { computed, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import { Text } from "../components";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        width: 100
    }
});

interface CounterProps {
    label: string,
    from: number,
    to: number,
}

@observer
class Counter extends React.Component<WithStyles<ClassNames> & CounterProps> {

    public ptr: number;

    @observable public _count: number;

    @computed get count() { return this._count; }
    set count(count: number) { this._count = count; }

    public componentWillMount() {
        const {from} = this.props;
        this.count = from;
    }

    public componentWillUnmount() {
        window.clearInterval(this.ptr);
    }

    public start() {
        const {to} = this.props;
        this.ptr = window.setInterval(() => this.count === to ? clearInterval(this.ptr) : this.count += 1, 64);
    }

    public render() {
        const {count} = this;
        const {classes, label} = this.props;
        return (
            <div className={classes.container}>
                <Text variant="title3" align="center" gutterBottom={false}>{`${count}`}</Text>
                <Text variant="footnote" align="center">{label}</Text>
            </div>
        );
    }
}

export default withStyles(styles)<CounterProps>(Counter);



// WEBPACK FOOTER //
// ./src/elements/Counter.tsx